<template>
  <div class="about">
    <header class="header">
      <button class="back" @click="$router.push('/')">Menüye geri dön</button>
      <h1>Hakkımızda</h1>
    </header>

    <section class="card">
      <h2>Deep Restoran</h2>
      <p>
        Deep, deniz esintisini koyu mavi tonlarla buluşturan, modern Ege
        mutfağına odaklanan bir restorandır. Taptaze ürünler, özenli
        sunumlar ve sakin bir atmosferle misafirlerini ağırlar.
      </p>
    </section>

    <section class="grid">
      <div class="mini">
        <h3>Konsept</h3>
        <p>Mevsimsel menüler, sürdürülebilir tedarik, sade şıklık.</p>
      </div>
      <div class="mini">
        <h3>Şef Dokunuşu</h3>
        <p>Geleneksel tariflere modern yorum, dengeli ve temiz lezzet.</p>
      </div>
      <div class="mini">
        <h3>Ritüel</h3>
        <p>Gün batımı eşliğinde uzun sofralar, keyifli paylaşım.</p>
      </div>
    </section>
  </div>
</template>

<style scoped>
.about {
  padding-bottom: 40px;
}
.header {
  padding: 16px;
  color: var(--text);
  background: linear-gradient(180deg, rgba(8, 26, 51, 0.95), rgba(8, 26, 51, 0));
}
.back {
  background: transparent;
  color: var(--muted);
  border: 1px solid rgba(73, 182, 255, 0.25);
  padding: 6px 12px;
  border-radius: 999px;
  font-size: 12px;
  letter-spacing: 0.8px;
  text-transform: uppercase;
  cursor: pointer;
}
.card {
  margin: 10px 16px 20px;
  padding: 18px;
  background: var(--card-strong);
  border-radius: 20px;
  border: 1px solid rgba(73, 182, 255, 0.12);
  box-shadow: 0 16px 30px rgba(3, 12, 30, 0.45);
}
.card h2 {
  margin: 0 0 8px;
  color: var(--text);
}
.card p {
  margin: 0;
  color: var(--muted);
  line-height: 1.6;
}
.grid {
  display: grid;
  gap: 14px;
  padding: 0 16px;
}
.mini {
  padding: 14px 16px;
  background: var(--card);
  border-radius: 16px;
  border: 1px solid rgba(73, 182, 255, 0.12);
}
.mini h3 {
  margin: 0 0 6px;
  color: var(--text);
}
.mini p {
  margin: 0;
  color: var(--muted);
  font-size: 13px;
  line-height: 1.5;
}
</style>
